export const getOcppBaseUrl = () => {
  const hostname = window.location.hostname;
  switch (hostname) {
    case "portal.stg.pleevi.ai":
      return "wss://ocpp-broker.stg.pleevi.ai";
    case "portal.sbx.pleevi.ai":
      return "wss://ocpp-broker.sbx.pleevi.ai";
    case "portal.pleevi.ai":
      return "wss://ocpp-broker.pleevi.ai";
    default:
      return "ws://localhost:9080";
  }
};
